
import './App.css';
import './bootstrap.min.css';
import Rotas from './routes/routes';

export default function App() {
  return (
    <div className="App">
      <Rotas />
    </div>
  );
}
